import { Injectable } from '@angular/core';
import { RequestService } from '../request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ModalPesquisaService {
  constructor(private _requestService: RequestService) {}

  infoModalPesquisa(companyID: string, restrictionKey: string, userID: string) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
      userID: userID != null ? userID : '',
    };

    return this._requestService.requestMethod(
      `user/api/User/Get/ModalSurvey/${userID}`,
      'GET',
      true,
      null,
      header
    );
  }

  enviarPesquisa(companyID, restrictionKey, data) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey,
      companyID: companyID,
    };
    return this._requestService.requestMethod(
      `user/api/User/Include/Response/ModalSurvey`,
      'POST',
      true,
      data,
      header
    );
  }

  pesquisaNPS(companyID, restrictionKey, data) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey,
      companyID: companyID,
    };
    return this._requestService.requestMethod(
      `user/research/nps`,
      'POST',
      true,
      data,
      header
    );
  }

  verificarRespostaNPS(
    companyID: string,
    restrictionKey: string,
    userID: string
  ) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
      userID: userID != null ? userID : '',
    };

    return this._requestService.requestMethod(
      `user/research/nps/check-response/${userID}`,
      'GET',
      true,
      null,
      header
    );
  }
}
